import React, { useEffect } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import useDelete from '../customHooks/useDelete';
import { toast } from 'react-toastify';
import profileImg from '../dist/webImages/profile2.png'




const UserCard = ({ data, alldata, deleted }) => {
  const { id, name, username, email, profile_image, role } = data
  const [resDelete, apiMethodDelete] = useDelete()
  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want to delete?",
      buttons: true,
      icon: "warning",
      dangerMode: true,
    })
      .then(willDelete => {
        if (willDelete) {
          swal("Successfully Delete", "", "success");
          apiMethodDelete(`userDelete/${id}`)
        }
      });
  }
  useEffect(() => {
    if (resDelete.data) {
      const { message } = resDelete.data
      const update = alldata.filter((item) => item.id !== id)
      deleted(update)
      toast.success(message);
    }
  }, [resDelete.data])



  return (
    <div className='lawyerCard h-full relative bg-[#fff] border border-[#D4DEF1] rounded-[20px] shadow-custom p-4'>
      <div className="lawyerCard_ flex flex-col items-center gap-2 ">
        <div className="lawyerCard__img">
          <img className='h-[10rem] w-[10rem] object-cover rounded-full' src={profile_image ?? profileImg} alt={username} />
        </div>
        <div className="lawyerCard__txt text-center" >
          <div className="h2 text-[1.25rem] font-Mluvka leading-[1] break-all ">{username}</div>
          <p className='leading-[1] mt-1 font-semibold font-Cinzel text-[1.2rem]'>{name}</p>
          <p className='leading-[1] mt-1  text-[.9rem]'>({role})</p>
          {/* <p className='leading-[1] mt-1 text-primary text-[.7rem] text-wrap'>{email}</p> */}
        </div>
      </div>
      <div className="mt-2">
        <div className='closeButton cursor-pointer absolute bg-[#FFCEDA] w-[1.5rem] h-[1.5rem] p-[.5rem] top-[.7rem] right-[.7rem] grid place-items-center rounded-full z-10' onClick={handleDelete}>
          <svg className='w-full h-full' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8612 1.34766L0.951172 16.2567M15.8612 16.2577L0.951172 1.34863" stroke="#ED2656" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <Link to={`/users/edit/${id}`} className='cursor-pointer relative '>
          <button className='bg-[#A38560]/50 w-fit mx-auto px-2 text-secondary text-[.8rem] grid place-items-center rounded-[.3rem] z-10'>
            Edit
          </button>
        </Link>
      </div>
    </div>
  )
}

export default UserCard
